import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { BriefSummary } from "../types";

interface Props {
  brief: BriefSummary | null;
  content: string | null;
  loading: boolean;
  error: string | null;
}

export function BriefReader({ brief, content, loading, error }: Props) {
  return (
    <section className="panel brief-reader">
      <div className="panel-header">
        <h2>{brief ? brief.filename : "Reader"}</h2>
      </div>
      <div className="panel-body scroll">
        {!brief && <div className="notice muted">Select a brief from the left to read it.</div>}
        {brief && loading && <div className="notice muted">Loading…</div>}
        {brief && error && <div className="notice error">{error}</div>}
        {brief && !loading && !error && content != null && (
          <article className="markdown">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </article>
        )}
      </div>
    </section>
  );
}
